export default function (initialDataInteractor, workspaceName, workspaceId, workspaceMemberIds) {
  initialDataInteractor.data.workspaces
    .push({
      'name': workspaceName,
      'id': workspaceId,
      'people': workspaceMemberIds
    });
}